import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { Property } from 'shared-types/Property';
import type { JourneyPickerCategory } from 'voyager';
import { useHomeCategories } from '@features/Home/v2/useHomeCategories';
import { entitySelectors } from '@store/entity/selectors';
import { settingSelectors } from '@store/setting/selectors';

export function useNavCategories(): JourneyPickerCategory[] {
  const property = useSelector(entitySelectors.getProperty) as Property;
  const language = (useSelector(settingSelectors.getUserLanguage) as string | undefined) ?? 'en';

  const { categories } = useHomeCategories({ property, language });

  return useMemo(
    () =>
      categories.map(({ id, label, imageUrl }) => ({
        id,
        label,
        imageUrl: imageUrl ?? undefined,
        imageAlt: label,
      })),
    [categories]
  );
}
